"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uint8ArrayToBase64 = uint8ArrayToBase64;
exports.base64ToUint8Array = base64ToUint8Array;
function uint8ArrayToBase64(bytes) {
    const nodeBuf = globalThis.Buffer;
    if (nodeBuf) {
        return nodeBuf.from(bytes).toString('base64');
    }
    const chunks = [];
    const chunkSize = 0x8000;
    for (let offset = 0; offset < bytes.length; offset += chunkSize) {
        chunks.push(String.fromCharCode(...bytes.subarray(offset, offset + chunkSize)));
    }
    return btoa(chunks.join(''));
}
function base64ToUint8Array(base64) {
    const nodeBuf = globalThis.Buffer;
    if (nodeBuf) {
        return new Uint8Array(nodeBuf.from(base64, 'base64'));
    }
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}
//# sourceMappingURL=base64.js.map